import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { startUserTrial, fetchPackages } from "../../../redux/actions/packageAction";
import { saveUserCredentials } from "../../../redux/actions/user";
import {
  getLocalStorageObject,
  removeKeyLocalStorageObject,
  setLocalStorageObject,
} from "../../../util/helper";
import StaticPopup from "../../utilities/Static-Popup";
import ConfirmModal from "../../utilities/confirm-modal";
import BrokerService from "../../../services/broker.service";
import PeriodSelector from "./PeriodSelector";
import PricingCard from "./PricingCard";
import PlanFeatureCards from "./PlanFeatureCards";
import { planFeatures } from "./planFeatures";
import "./Pricing.scss";
import BrokerCard from "../../authentication/simple/BrokerCard";
import paisa from "../../../assets/img/login-img/5paisa.webp";
import firstock from "../../../assets/img/login-img/firstock.png";
import PlusMinQty from "../../utilities/PlusMinQty";
import TrialSucessModal from "./TrialSucessModal";
import TrialStatusModal from "./TrialStatusModal";
import { useToast } from "components/common/custom-toast/Toast";
import moment from "moment";

let localStorageObj = getLocalStorageObject("selectedPlan") || {
  plan: "",
};

const Pricing = () => {
  const [loading, setLoading] = useState(true);
  const [period, setPeriod] = useState("m");
  const [quiktradePackages, setQuiktradePackages] = useState([]);
  const isLoggedIn = useSelector((state) => state?.user?.isLoggedIn);
  const [show, setShow] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loginShow, setLoginShow] = useState(false);
  const [trialPopup, setTrialPopup] = useState(false);
  const [trialPopupText, setTrialPopupText] = useState([]);
  const navigate = useNavigate();
  const trialAllowed = useSelector((state) => state?.user?.trialAllowed);
  const tradeTrailAllowed = useSelector(
    (state) => state?.user?.tradeTrailAllowed
  );
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [trailPopup, setTrailPopup] = useState(false);
  const [brokersModalOpen, setBrokersModalOpen] = useState(false);
  const [planModalOpen, setPlanModalOpen] = useState(false);
  const [planForModal, setPlanForModal] = useState(null);
  const [additionalBrokerCount, setAdditionalBrokerCount] = useState(0);
  const [trialSuccessModal, setTrialSuccessModal] = useState(false);
  const [trialExpiryInfo, setTrialExpiryInfo] = useState({
    open: false,
    type: "",
    expiryDate: "",
    productName: "QuikTrade"
  });
  const toast = useToast()


  const handleTrialExpiryCheck = (data) => {
    const trialData = data?.trial;
    if (
      trialData?.subscriptionValidTill &&
      trialData?.subscriptionValidTill !== "0001-01-01T00:00:00Z"
    ) {
      const expiryDate = moment(trialData.subscriptionValidTill);
      const now = moment();
      const diffInDays = expiryDate.diff(now, "days");

      if (expiryDate.isBefore(now)) {
        setTrialExpiryInfo({
          open: true,
          type: "expired",
          expiryDate: trialData.subscriptionValidTill,
          productName: "QuikTrade Trial"
        });
        return true;
      } else if (diffInDays >= 0) {
        setTrialExpiryInfo({
          open: true,
          type: "ending",
          expiryDate: trialData.subscriptionValidTill,
          productName: "QuikTrade Trial"
        });
        return true;
      }
    }
    return false;
  };

  useEffect(() => {
    const fetchPricing = async () => {
      try {
        setLoading(true);
        const [qtRes, sipRes] = await Promise.all([
          dispatch(fetchPackages({ product_type: "qt-new" })),
          dispatch(fetchPackages({ product_type: "sip" }))
        ]);

        setQuiktradePackages([
          ...(qtRes?.packages || []),
          ...(sipRes?.packages || [])
        ]);
      } catch (error) {
        console.error("Error fetching packages:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPricing();
  }, [dispatch]);

  const getQuiktradePackagesByType = (planType, selectedPeriod) => {
    const days = selectedPeriod === "trial" ? 7 : (selectedPeriod === "y" ? 360 : 30);
    return quiktradePackages.find(
      (pkg) => pkg.planType === planType && pkg.numberOfDays === days
    );
  };

  const trialPackage = getQuiktradePackagesByType("7 Days plan", "trial");
  const manualPackage = getQuiktradePackagesByType("Terminal", period);
  const signalsPackage = getQuiktradePackagesByType("Algo Signals", period);
  const comboPackage = getQuiktradePackagesByType("Combo", period);
  const unlimitedPackage = getQuiktradePackagesByType("Unlimited", period);
  const addBrokerPackage = getQuiktradePackagesByType("Add Brokers", period);
  const staticIPPackage = getQuiktradePackagesByType("Static IP", period);

  const getPrice = (pkg) => {
    if (!pkg) return 0;
    return pkg.finalPrice || 0;
  };

  const getOriginal = (pkg) => {
    if (!pkg) return undefined;
    return pkg.price || undefined;
  };

  const getDiscount = (pkg) => {
    if (!pkg) return 0;
    const original = pkg.price || 0;
    const discounted = pkg.costPerDay || 0;
    if (!original || !discounted || discounted >= original) return 0;
    return Math.round(((original - discounted) / original) * 100);
  };

  const getTrialDays = () => {
    const daysMap = { m: "30 days", y: "360 days" };
    return daysMap[period] || "30 days";
  };

  const openBrokersModal = () => {
    setBrokersModalOpen(true);
  };

  const openPlanModal = (pkg) => {
    if (!pkg) {
      toast.error("The selected plan is currently unavailable.");
      return;
    }

    if (pkg.planType === "Static IP") {
      if (isLoggedIn) {
        navigate("/payment", {
          state: { selectedPlan: pkg }
        });
      } else {
        setLoginShow(true);
      }
      return;
    }

    setPlanForModal(pkg);
    if (pkg.planType === "Add Brokers") {
      setAdditionalBrokerCount(1);
    } else {
      setAdditionalBrokerCount(0);
    }
    setPlanModalOpen(true);
  };

  const closeAllModals = () => {
    setBrokersModalOpen(false);
    setPlanModalOpen(false);
  };

  const incrementAdditional = () => {
    setAdditionalBrokerCount((c) => c + 1);
  };

  const decrementAdditional = () => {
    setAdditionalBrokerCount((c) => (c > 0 ? c - 1 : 0));
  };

  const handleAdditionalQty = (next) => {
    const numeric = parseInt(next);
    setAdditionalBrokerCount(Number.isNaN(numeric) ? 0 : Math.max(0, numeric));
  };

  const computeModalTotals = () => {
    const original = getOriginal(planForModal);
    const net = getPrice(planForModal);
    const isStandaloneAddon = planForModal?.planType === "Add Brokers" || planForModal?.planType === "Static IP";

    const addOnUnit = isStandaloneAddon ? net : getPrice(addBrokerPackage);
    const addOnTotal = addOnUnit * additionalBrokerCount;

    const subtotal = isStandaloneAddon ? addOnTotal : net + addOnTotal;
    const gst = +(subtotal * 0.18).toFixed(2);
    const total = +(subtotal + gst).toFixed(2);
    return { original, net, addOnUnit, addOnTotal, subtotal, gst, total };
  };

const startFreeTrial = async (type = 'qt-new') => {
  try {
    const res = await startUserTrial(type);
    if (res?.extendedTime) {
      setTrialSuccessModal(true);
    }
  } catch (error) {
    console.error('Failed to start trial:', error);
  }
};

  const BuyPlan = (plan) => {
    BrokerService.loginStatusCheck().then((response) => {
      var data = response?.data;
      if (!isLoggedIn) {
        setLoginShow((loginShow) => !loginShow);
      }
      setSelectedPlan(plan);
      if (isLoggedIn && plan == "Free" && data?.activeTradeSubscription) {
        toast.error(
          "Free Trial is provided once per user and you have used it. Please purchase a Plan to continue."
        );
      } else if (
        isLoggedIn &&
        plan.planName == "Free" &&
        !data?.activeTradeSubscription
      ) {
        startFreeTrial("qt");
      } else {
        setLocalStorageObject("selectedPlan", "plan", plan, localStorageObj);
      }
    });
  };

  const openConfirmModal = (item) => {
    BrokerService.loginStatusCheck().then(
      (response) => {
        var data = response?.data;

        setSelectedPlan(item);
        if (item.planName == "Trial" && data?.activeSubscription) {
          toast.error(
            "Free Trial is provided once per user and you have used it. Please purchase a Plan to continue."
          );
        } else {
          try {
            const addOnUnit = getPrice(addBrokerPackage);
            const addOnTotal = addOnUnit * additionalBrokerCount;
            const planWithAddOns = {
              ...item,
              additionalBrokerCount: additionalBrokerCount,
              addOnUnitPrice: addOnUnit,
              addOnTotalPrice: addOnTotal,
            };
            setLocalStorageObject("selectedPlan", "plan", planWithAddOns, localStorageObj);
          } catch (e) {
            setLocalStorageObject("selectedPlan", "plan", item, localStorageObj);
          }
          navigate("/payment", {
            state: { selectedPlan: item }
          });
        }
      },
      (error) => { }
    );
  };

  const handleBtnClick = (isBoth) => {
    setTrailPopup(false);
    if (isBoth) {
      startFreeTrial('d');
      startFreeTrial("qt");
    } else {
      if (selectedPlan.planName == "Trial") {
        startFreeTrial('d');
      } else {
        startFreeTrial("qt");
      }
    }
  };

  const handleTrialClick = () => {
    if (isLoggedIn) {
      BrokerService.loginStatusCheck().then((res) => {
        if (!handleTrialExpiryCheck(res?.data)) {
          startFreeTrial();
        }
      });
    } else {
      setLoginShow(true);
    }
  };

  return (
    <section className="pricing-section">
      <div className="container">
        <div className="header">
          <h2 className="title">Simple, Transparent Pricing</h2>
          <p className="subtitle">Choose the plan that's right for you</p>
        </div>


        <PeriodSelector period={period} setPeriod={setPeriod} />

        {loading ? (
          <div className="loading-state">Loading...</div>
        ) : (
          <>
            <div className="trial-banner">
              <div className="trial-banner-icon">🎉</div>
              <div className="trial-banner-content">
                <div className="trial-banner-title">Start your 7 day risk-free trial</div>
                <div className="trial-banner-subtitle">
                  Try QuikTrade for 7 days
                </div>
              </div>
              <button
                onClick={handleTrialClick}
                className="trial-banner-button"
              >
                Start Trial
              </button>
            </div>
            <div className="quiktrade-pricing-grid">
              <PricingCard
                type="standard"
                title="Firstock & 5Paisa"
                price={0}
                validity="Unlimited"
                gradientFrom="blue-100"
                buttonColor="bg-blue-600 hover:bg-blue-700"
                onClick={openBrokersModal}
              />
              <PricingCard
                type="standard"
                title="Terminal"
                originalPrice={getOriginal(manualPackage)}
                price={getPrice(manualPackage)}
                discountPercent={getDiscount(manualPackage)}
                pricePeriod={period === "y" ? "year" : "month"}
                validity={getTrialDays()}
                gradientFrom="orange-100"
                buttonColor="bg-orange-500 hover:bg-orange-600"
                onClick={() => openPlanModal(manualPackage)}
              />
              <PricingCard
                type="standard"
                title="Algo Signals"
                originalPrice={getOriginal(signalsPackage)}
                price={getPrice(signalsPackage)}
                discountPercent={getDiscount(signalsPackage)}
                pricePeriod={period === "y" ? "year" : "month"}
                validity={getTrialDays()}
                gradientFrom="green-100"
                buttonColor="bg-green-600 hover:bg-green-700"
                onClick={() => openPlanModal(signalsPackage)}
              />
              <PricingCard
                type="standard"
                title="Unlimited (Terminal + Algo Signals)"
                originalPrice={getOriginal(unlimitedPackage)}
                price={getPrice(unlimitedPackage)}
                discountPercent={getDiscount(unlimitedPackage)}
                pricePeriod={period === "y" ? "year" : "month"}
                validity={getTrialDays()}
                gradientFrom="purple-100"
                buttonColor="bg-purple-600 hover:bg-purple-700"
                onClick={() => openPlanModal(unlimitedPackage)}
              />
              <PricingCard
                type="popular"
                title="Combo (Discover + QuikTrade Unlimited)"
                originalPrice={getOriginal(comboPackage)}
                price={getPrice(comboPackage)}
                discountPercent={getDiscount(comboPackage)}
                pricePeriod={period === "y" ? "year" : "month"}
                validity={getTrialDays()}
                gradientFrom="yellow-100"
                buttonColor="bg-yellow-600 hover:bg-yellow-700"
                onClick={() => openPlanModal(comboPackage)}
              />
              <PricingCard
                type="addon"
                title="Additional Brokers"
                subtitle="Multi-account trading"
                originalPrice={getOriginal(addBrokerPackage)}
                price={getPrice(addBrokerPackage)}
                discountPercent={getDiscount(addBrokerPackage)}
                pricePeriod={period === "y" ? "year" : "month"}
                validity={getTrialDays()}
                gradientFrom="neutral-100"
                buttonColor="bg-neutral-600 hover:bg-neutral-700"
                onClick={() => openPlanModal(addBrokerPackage)}
                description="Want multi-account trading? Buy an add-on plan to access more accounts."
              />
              {period !== "y" && (
                <PricingCard
                  type="standard"
                  title="Dedicated Static IP"
                  subtitle="For safe trading"
                  originalPrice={getOriginal(staticIPPackage)}
                  price={getPrice(staticIPPackage)}
                  discountPercent={getDiscount(staticIPPackage)}
                  pricePeriod={period === "y" ? "year" : "month"}
                  validity={getTrialDays()}
                  gradientFrom="blue-100"
                  buttonColor="bg-blue-600 hover:bg-blue-700"
                  onClick={() => openPlanModal(staticIPPackage)}
                  description="Get a dedicated IP for reliable, whitelist-ready connectivity."
                />
              )}
            </div>
          </>
        )}

        <div className="feature-section">
          <div className="feature-header">
            <h2 className="feature-title">Plan Features</h2>
            <p className="feature-description">Compare plans to find the perfect fit for your trading needs</p>
          </div>
          <PlanFeatureCards plans={planFeatures} />
        </div>

        <div className="terms--section">
          <h2 className="terms-title">Terms and Conditions</h2>
          <div className="terms-list">
            <p className="terms-item">
              We use Official Snapshot data feed from NSE Data & Analytics Ltd &
              Real-time analysis powered by Broker API data feed.
            </p>
            <p className="terms-item">
              FNOTrader Discover does not provide buy/sell recommendations; it
              provides the user with all the insights to make informed
              decisions.
            </p>
            <p className="terms-item">
              We are NOT a SEBI registered Advisor, and we are NOT responsible
              for your trading profits/losses if you use our data for analysis
              and trading.
            </p>
            <p className="terms-item">
              FNOTrader Discover and QuikTrade are two different products and
              are complementary to the trader to find trade opportunities and
              execute them through broker API.
            </p>
            <p className="terms-item">
              Prices are exclusive of the applicable GST (which is 18%).
            </p>
            <p className="terms-item">
              Monthly subscription means a 30-day subscription period.
            </p>
            <p className="terms-item">
              We may or may not be able to restore any missing data in case of
              data feed disruptions. We will try our best to restore the missing
              data.
            </p>
            <p className="terms-item">
              In case of any major service disruption, we will add hours/days to
              your subscription/access, but it will not be possible to refund
              due to the low price we charge for our service.
            </p>
          </div>
        </div>

        <div className="disclaimer-section">
          <h2 className="disclaimer-title">Disclaimer</h2>
          <p className="disclaimer-text">
            Although information has been obtained from and is based upon
            sources we believe to be reliable, we do not guarantee its accuracy,
            and the information may be incomplete or condensed.
          </p>
          <p className="disclaimer-text">
            Any opinions, chats, messages, news, research, analyses, prices, or
            other information contained on this Website are provided as general
            market information for educational purposes only.
          </p>
          <p className="disclaimer-text">
            None of the stock information, data, and company information
            presented herein constitutes a legally binding recommendation or a
            solicitation of any offer to buy or sell any securities. Information
            presented is general information that does not take into account
            your individual circumstances, financial situation, or needs, nor
            does it present a personalized recommendation to you. Individual
            stocks presented may not be suitable for you.
          </p>
          <p className="disclaimer-text">
            Opinions, market data, recommendations, or any other content are
            subject to change at any time without notice. We will not accept
            liability for any loss or damage, including without limitation to
            any reduction of profits, which may arise directly or indirectly
            from the use of or reliance on such information. We are a technology
            company and not an investment/trading advisor. Please consult a
            Registered Financial Adviser about the appropriateness of your
            investment/trading decisions.
          </p>
        </div>
      </div>

      <ConfirmModal
        show={show}
        onConfirm={() => openConfirmModal(selectedPlan)}
        onClose={() => setShow(false)}
        title="Are You Sure?"
        message="Do you want to proceed with this plan?"
      />

      <StaticPopup
        message={["So we can map your account!"]}
        title="Please login"
        isShow={loginShow}
        link="/authentication/login"
        btnText_1="OK"
        btnText_2=""
        page="/pricing"
        handleClosePopup={() => setLoginShow(false)}
        handleBtnClick={() => setLoginShow(false)}
        closebtn={false}
      />

      <StaticPopup
        message={trialPopupText}
        title="Free Trial Activated"
        isShow={trialPopup}
        link="/pricing"
        btnText_1="Yes"
        btnText_2="No"
        page="discover/pricing/plan"
        handleClosePopup={() => setTrailPopup(false)}
        handleBtnClick={() => handleBtnClick(false)}
        closebtn={true}
      />

      <Modal
        title="Preferred Brokers"
        open={brokersModalOpen}
        onCancel={closeAllModals}
        footer={null}
        width={720}
      >
        <div className="section-content">
          <div className="brokers-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <BrokerCard
              logoSrc={paisa}
              name="5Paisa"
              status="Analysis only"
              onClick={() => window.open('https://www.5paisa.com/demat-account?ReferralCode=57003172&ReturnUrl=invest-open-account', '_blank')}
            />
            <BrokerCard
              logoSrc={firstock}
              name="Firstock"
              status="Analysis only"
              onClick={() => window.open('https://signup.firstock.in/?p=FNO99', '_blank')}
            />
          </div>
          <div className="important-note" style={{ marginTop: 16 }}>
            <ul>
              <li>Once your account is opened successfully through the above link, please reach us on whatsapp to enable free access to all our QuikTrade products.</li>
            </ul>
          </div>
        </div>
      </Modal>

      <Modal
        title={planForModal ? `${planForModal.planType === "Combo" ? "Combo (Discover + QuikTrade Unlimited)" : planForModal.planType} Pricing` : 'Pricing'}
        open={planModalOpen}
        onCancel={closeAllModals}
        footer={null}
        width={720}
      >
        {planForModal && (
          <div>
            {planForModal.planType !== "Static IP" && <div className="important-note">
              <ul style={{marginBottom: 0}}>
                {planForModal.planType !== "Add Brokers" ? (
                  <>
                  <li>
                    This pricing supports unlimited strategies for 1 broker account.
                  </li>
                <li>
                  For additional broker accounts to be used parallely, please purchase Add On plan.
                </li>
                </>
                ) :
                <>
                <li>Base Plan provides access for 1 broker account at a time.</li>
                <li>If you want to trade multiple accounts simultaneously, please purchase add-on plan from below.</li>
                <li>Select the no of accounts, you want to trade and complete the purchase.</li>
                </>}
              </ul>
            </div>} 
              <div className="additional-broker-account">
                <span style={{ minWidth: 220 }}>{planForModal.planType === "Static IP" ? "Number of IPs" : "Additional Broker Account"}</span>
                <PlusMinQty
                  qtyClick={(count) => handleAdditionalQty(count)}
                  filterValue={additionalBrokerCount}
                  name={planForModal.planType === "Static IP" ? "staticIPs" : "additionalBrokers"}
                  min={planForModal.planType === "Add Brokers" || planForModal.planType === "Static IP" ? 1 : 0}
                  step={1}
                  page="pricing"
                  handleKeyDown={() => { }}
                />
              </div>

            {(() => {
              const t = computeModalTotals();
              return (
                <div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', rowGap: 8 }}>
                    {planForModal.planType !== "Add Brokers" && planForModal.planType !== "Static IP" &&
                    <>
                    <div>Original Price</div>
                    <div className="price-text">₹{t?.original?.toLocaleString('en-IN')}</div>
                    <div>Net Price</div>
                    <div className="price-text">₹{t?.net?.toLocaleString('en-IN')}</div>
                    </>
                    }
                    <div>{planForModal.planType === "Static IP" ? "Price per IP" : "Add-on (per broker)"} × {additionalBrokerCount}</div>
                        <div className="price-text">₹{t?.addOnTotal?.toLocaleString('en-IN')}</div>
                    <div style={{ borderTop: '1px solid #eee', marginTop: 8 }}></div>
                    <div style={{ borderTop: '1px solid #eee', marginTop: 8 }}></div>
                    <div>Subtotal</div>
                    <div className="price-text">₹{t.subtotal.toLocaleString('en-IN')}</div>
                    <div>GST (18%)</div>
                    <div className="price-text">₹{t.gst.toLocaleString('en-IN')}</div>
                    <div className="total-text">Total</div>
                    <div className="price-text total-price">₹{t.total.toLocaleString('en-IN')}</div>
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ width: '100%', marginTop: "1.5rem" }}
                    onClick={() => (isLoggedIn ? openConfirmModal(planForModal) : BuyPlan(planForModal))}
                  >
                    Buy
                  </button>
                </div>
              );
            })()}
          </div>
        )}
      </Modal>
      <TrialSucessModal trialSuccessModal={trialSuccessModal} setTrialSuccessModal={setTrialSuccessModal} />
      <TrialStatusModal
        open={trialExpiryInfo.open}
        type={trialExpiryInfo.type}
        expiryDate={trialExpiryInfo.expiryDate}
        productName={trialExpiryInfo.productName}
        onClose={() => setTrialExpiryInfo({ ...trialExpiryInfo, open: false })}
      />
    </section>
  );
};

export default Pricing;